<script setup lang="ts">
import { devToolBridges } from '@bridge'
</script>

<template>
  <section class="dev-section">
    <h4 class="dev-section-title">인터페이스(브릿지)</h4>

    <div class="section-inner">
      <NovaDevToolsBridgeTool
        v-for="item in devToolBridges"
        :key="item.handlerKey"
        :bridge="item"
      />
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '@styles/base/dev-tools';
@include dev-tools-section;
</style>
